/* cl-pdp: comportamento do buybox copiado (Horizon da Leonie; o Kaching vem por APP no slot).
   O form da pagina e o do bloco nativo buy_buttons do Shrine; aqui escrevemos a variante nele,
   trocamos preco/galeria e, com um kit escolhido, mandamos UMA linha por unidade (cor/tamanho
   de cada linha) + o brinde para /cart/add.js e abrimos a gaveta. As setas da galeria ficam
   com o cl-interactive.js (carrossel generico por scroll). */
(function(){
  function each(r, s, fn){ [].forEach.call(r.querySelectorAll(s), fn); }
  function money(c, fmt){
    fmt = fmt || '{{amount}}';
    var n = (c / 100);
    function grp(x, sep){ return x.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      var v;
      if (k === 'amount_no_decimals') v = grp(Math.round(n).toString(), ',');
      else if (k === 'amount_with_comma_separator') { var p = n.toFixed(2).split('.'); v = grp(p[0], '.') + ',' + p[1]; }
      else if (k === 'amount_no_decimals_with_comma_separator') v = grp(Math.round(n).toString(), '.');
      else { var r = n.toFixed(2).split('.'); v = grp(r[0], ',') + '.' + r[1]; }
      return v.replace(/[.,]00$/, '');
    });
  }

  function initPdp(root){
    if (root.__cl) return; root.__cl = true;
    var data = {};
    try { data = JSON.parse(root.querySelector('script[data-cl-product]').textContent); } catch(e){}
    var variants = data.variants || [], fmt = data.money;
    var formId = root.getAttribute('data-form-id');
    var form = document.getElementById(formId);
    var cur = variants.filter(function(v){ return v.available; })[0] || variants[0];
    var qs = new URLSearchParams(location.search).get('variant');
    if (qs) cur = variants.filter(function(v){ return String(v.id) === qs; })[0] || cur;
    var sel = cur ? cur.options.slice() : [];
    function find(opts){ return variants.filter(function(v){ return v.options.every(function(o, i){ return o === opts[i]; }); })[0]; }

    /* --- slot do app (Kaching por APP, ordem do operador): o form NATIVO (buy_buttons) e
       qualquer bloco de app do main-product vao para o lugar do widget dele --- */
    var slot = root.querySelector('[data-cl-app-slot]'), hasApp = false;
    var box = root.closest('.product__info-container');
    function fillSlot(){
      if (!slot || !box) return;
      [].slice.call(box.children).forEach(function(ch){
        if (ch.classList.contains('cl-pdp-host') || slot.contains(ch)) return;
        var app = ch.matches('.shopify-app-block, [id^="shopify-block-"]') || !!ch.querySelector('.shopify-app-block, kaching-bundle');
        var isForm = form && ch.contains(form);
        if (app || isForm) { slot.appendChild(ch); if (app) hasApp = true; }
      });
      root.classList.toggle('cl-has-app', hasApp);
    }
    fillSlot();
    if (box && 'MutationObserver' in window) new MutationObserver(fillSlot).observe(box, {childList: true});

    /* --- galeria: miniatura -> slide; slide visivel -> miniatura marcada --- */
    var scroller = root.querySelector('cl-media-gallery cl-slideshow-slides');
    var slides = [].slice.call(root.querySelectorAll('cl-media-gallery cl-slideshow-slide'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-cl-thumb]'));
    function goSlide(i){
      if (!scroller || !slides[i]) return;
      scroller.scrollTo({left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'auto'});
      mark(i);
    }
    function mark(i){
      slides.forEach(function(s, k){ s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      thumbs.forEach(function(t, k){ t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      var th = root.querySelector('.slideshow-controls__slider-thumb');
      if (th && slides.length) th.style.insetInlineStart = (100 * i / slides.length) + '%';
    }
    thumbs.forEach(function(t){ t.addEventListener('click', function(e){ e.preventDefault(); goSlide(+t.getAttribute('data-cl-thumb')); }); });
    if (scroller) scroller.addEventListener('scroll', function(){
      var x = scroller.scrollLeft, w = scroller.clientWidth || 1;
      mark(Math.max(0, Math.min(slides.length - 1, Math.round(x / w))));
    }, {passive: true});
    each(root, '.thumbnail-carousel__arrow', function(b){
      b.addEventListener('click', function(e){
        e.preventDefault();
        var box = root.querySelector('.slideshow-controls__thumbnails-container');
        if (box) box.scrollBy({top: (b.classList.contains('thumbnail-carousel__arrow--next') ? 1 : -1) * 180, behavior: 'smooth'});
      });
    });

    /* --- precos / variante --- */
    function setPrices(v){
      each(root, 'cl-product-price', function(pp){
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        each(pp, '.clx-price__regular .clx-price, .clx-price-item--sale', function(e){ e.textContent = money(v.price, fmt); });
        each(pp, '.compare-at-price', function(e){ e.textContent = onSale ? money(v.compare_at_price, fmt) : ''; });
        var r = pp.querySelector('.clx-price__regular'), s = pp.querySelector('.clx-price__sale');
        if (r) r.classList.toggle('price__hidden', !!onSale);
        if (s) s.classList.toggle('price__hidden', !onSale);
      });
      var onS = v.compare_at_price && v.compare_at_price > v.price;
      each(root, '.lc-atc__now', function(e){ e.textContent = money(v.price, fmt); });
      each(root, '.lc-atc__was', function(e){ e.textContent = onS ? money(v.compare_at_price, fmt) : ''; });
      var st = root.querySelector('.sticky-add-to-cart__variant'); if (st && v.title !== 'Default Title') st.textContent = v.title;
    }
    function setForm(v){
      if (form) {
        var inp = form.querySelector('input[name="id"], select[name="id"]');
        if (inp) { inp.value = v.id; inp.dispatchEvent(new Event('change', {bubbles: true})); }
      }
      each(root, '[data-cl-atc]', function(b){ b.disabled = !v.available; });
    }
    function apply(push){
      var v = find(sel) || cur; if (!v) return;
      cur = v;
      each(root, 'input[data-cl-opt]', function(r){
        var i = +r.getAttribute('data-cl-opt');
        r.checked = r.value === sel[i];
        r.setAttribute('data-current-checked', r.checked ? 'true' : 'false');
      });
      each(root, '.variant-option__swatch-value', function(s){
        var fs = s.closest('fieldset'), idx = fs ? [].indexOf.call(root.querySelectorAll('cl-variant-picker fieldset'), fs) : 0;
        if (sel[idx] != null) s.textContent = sel[idx];
      });
      setPrices(v); setForm(v);
      if (v.featured_media) {
        var i = (data.media || []).indexOf(v.featured_media.id);
        if (i >= 0 && push) goSlide(i);
      }
      if (push && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
    }
    each(root, 'input[data-cl-opt]', function(r){
      r.addEventListener('change', function(){ sel[+r.getAttribute('data-cl-opt')] = r.value; apply(true); });
    });

    /* --- Kaching: barras --- */
    var bars = [].slice.call(root.querySelectorAll('[data-cl-kc-bar]'));
    var tier = bars.filter(function(b){ return b.classList.contains('kaching-bundles__bar--selected'); })[0] || bars[0] || null;
    function selectBar(b){
      tier = b;
      bars.forEach(function(o){
        o.classList.toggle('kaching-bundles__bar--selected', o === b);
        var r = o.querySelector('input[type="radio"]'); if (r) r.checked = o === b;
      });
    }
    bars.forEach(function(b){
      b.addEventListener('click', function(e){
        if (e.target.closest('select, [role="combobox"], [role="option"], .kaching-bundles__swatch-buttons, .kaching-bundles__swatch-dropdown')) return;
        if (e.target.closest('label, [role="button"], .kaching-bundles__bar-main')) e.preventDefault();
        selectBar(b);
      });
    });
    function rowValue(row, name){
      var el = row.querySelector('[data-name="' + name + '"]');
      return el ? (el.tagName === 'SELECT' ? el.value : el.getAttribute('data-value')) : null;
    }
    each(root, '[data-cl-kc-row]', function(row){
      /* cor em botoes (meia-calca) */
      each(row, '.kaching-bundles__swatch-buttons__button', function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          var box = btn.closest('.kaching-bundles__swatch-buttons');
          each(box, '.kaching-bundles__swatch-buttons__button', function(o){ o.classList.toggle('kaching-bundles__swatch-buttons__button--selected', o === btn); });
          box.setAttribute('data-value', btn.getAttribute('data-value'));
          var nv = btn.closest('.kaching-bundles__bar-variant-option').querySelector('.kaching-bundles__bar-variant-option__name-value');
          if (nv) nv.textContent = btn.getAttribute('data-value');
        });
      });
      /* cor em dropdown (macacao) */
      var dd = row.querySelector('.kaching-bundles__swatch-dropdown');
      if (dd) {
        var cb = dd.querySelector('[role="combobox"]'), list = dd.querySelector('[role="listbox"]');
        function close(){ if (list) list.style.display = 'none'; if (cb) cb.setAttribute('aria-expanded', 'false'); }
        if (cb) cb.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          var open = list && list.style.display === 'none';
          each(root, '.kaching-bundles__swatch-dropdown [role="listbox"]', function(l){ l.style.display = 'none'; });
          if (list) {
            list.style.display = open ? 'block' : 'none';
            if (open) { var rc = cb.getBoundingClientRect(); list.style.position = 'fixed'; list.style.left = rc.left + 'px'; list.style.top = (rc.bottom + 4) + 'px'; }
          }
          cb.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        each(dd, '[role="option"]', function(o){
          o.addEventListener('click', function(e){
            e.preventDefault(); e.stopPropagation();
            var val = o.getAttribute('data-value');
            dd.setAttribute('data-value', val);
            var sw = cb && cb.querySelector('.kaching-bundles__swatch'), osw = o.querySelector('.kaching-bundles__swatch');
            if (sw && osw) { sw.style.setProperty('--kaching-swatch-color', osw.style.getPropertyValue('--kaching-swatch-color')); sw.style.setProperty('--kaching-swatch-border-color', osw.style.getPropertyValue('--kaching-swatch-border-color')); }
            var t = cb && cb.querySelectorAll('span'); if (t && t.length) t[t.length - 1].textContent = val;
            each(dd, '[role="option"]', function(x){ x.setAttribute('aria-selected', x === o ? 'true' : 'false'); });
            close();
          });
        });
        document.addEventListener('click', function(e){ if (!dd.contains(e.target)) close(); });
        window.addEventListener('scroll', close, {passive: true});
      }
      each(row, 'select', function(s){ s.addEventListener('change', function(){ s.setAttribute('data-value', s.value); }); });
    });

    /* --- quantidade (produto sem kit) --- */
    each(root, 'cl-quantity-selector-component', function(qs){
      var inp = qs.querySelector('input'), minus = qs.querySelector('[name="minus"]'), plus = qs.querySelector('[name="plus"]');
      function set(n){ n = Math.max(1, n || 1); inp.value = n; if (minus) minus.disabled = n <= 1; }
      if (minus) minus.addEventListener('click', function(e){ e.preventDefault(); set((+inp.value || 1) - 1); });
      if (plus) plus.addEventListener('click', function(e){ e.preventDefault(); set((+inp.value || 1) + 1); });
      if (inp) inp.addEventListener('change', function(){ set(parseInt(inp.value, 10)); });
    });

    /* --- itens do pedido --- */
    function items(){
      var list = [];
      if (tier) {
        var rows = [].slice.call(tier.querySelectorAll('[data-cl-kc-row]'));
        var q = +(tier.getAttribute('data-qty') || 1), counts = {}, order = [];
        rows.slice(0, q).forEach(function(row){
          var opts = cur.options.slice();
          var names = (data.variants && data.variants[0] && data.variants[0].options) ? null : null;
          var c = rowValue(row, 'Color'), s = rowValue(row, 'Size');
          var o = (window.__clOptNames || []);
          opts = cur.options.slice();
          if (c != null) opts[0] = c;
          if (s != null) opts[opts.length > 1 ? 1 : 0] = s;
          var v = find(opts) || cur;
          if (!counts[v.id]) order.push(v.id);
          counts[v.id] = (counts[v.id] || 0) + 1;
        });
        if (!rows.length) { order.push(cur.id); counts[cur.id] = q; }
        order.forEach(function(id){ list.push({id: +id, quantity: counts[id]}); });
        var gift = tier.getAttribute('data-gift');
        if (gift) list.push({id: +gift, quantity: 1});
      } else if (cur) {
        var qi = root.querySelector('[data-cl-qty-visible]');
        list.push({id: cur.id, quantity: Math.max(1, parseInt(qi && qi.value, 10) || 1)});
      }
      return list;
    }
    function add(list, btn, then){
      if (btn) btn.setAttribute('aria-busy', 'true');
      return fetch(location.origin + '/cart/add.js', {method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Cl-Own': '1'},
        body: JSON.stringify({items: list})})
        .then(function(r){ if (!r.ok) throw r; return r.json(); })
        .then(then)
        .catch(function(){ alert('Sorry, this item is currently unavailable.'); })
        .then(function(){ if (btn) btn.removeAttribute('aria-busy'); });
    }
    document.addEventListener('click', function(e){
      var atc = e.target.closest && e.target.closest('[data-cl-atc]');
      if (atc && root.contains(atc)) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (hasApp && form) {           /* o app de bundle escolhe a variante e cuida do carrinho pelo form nativo */
          var sb = form.querySelector('[type="submit"]');
          if (sb) sb.click(); else if (form.requestSubmit) form.requestSubmit(); else form.submit();
          return;
        }
        if (!cur || !cur.available) return;
        add(items(), atc, function(){ if (window.clCartDrawer) { window.clCartDrawer.refresh().then(window.clCartDrawer.open); } else location.href = '/cart'; });
        return;
      }
      var bn = e.target.closest && e.target.closest('[data-cl-buynow]');
      if (bn && root.contains(bn)) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (!cur || !cur.available) return;
        add(items(), null, function(){ location.href = '/checkout'; });
      }
    }, true);

    /* --- barra fixa --- */
    var sticky = root.querySelector('cl-sticky-add-to-cart, .sticky-add-to-cart');
    var mainAtc = root.querySelector('[data-cl-atc]');
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(en){
        var e = en[0]; sticky.classList.toggle('cl-sticky-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainAtc);
    }
    each(root, '[data-cl-sticky-atc]', function(b){ b.addEventListener('click', function(e){ e.preventDefault(); if (mainAtc) mainAtc.click(); }); });

    apply(false);
  }
  function boot(){ each(document, '[data-cl-pdp]', initPdp); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
